// SPDX-License-Identifier: AGPL-3.0-or-later

import {Endpoints} from '@app/features/app/constants/Endpoints';
import {http} from '@app/features/platform/transport/RestTransport';
import {Logger} from '@app/features/platform/utils/AppLogger';
import type {MessageResponse} from '@fluxer/schema/src/domains/message/MessageResponseSchemas';
import type {PollCreateRequest, PollStatusResponse} from '@fluxer/schema/src/domains/message/PollSchemas';

const logger = new Logger('PollCommands');

export async function createPoll(channelId: string, data: PollCreateRequest): Promise<MessageResponse> {
	try {
		const response = await http.post<MessageResponse>(Endpoints.CHANNEL_POLLS(channelId), {body: data});
		return response.body;
	} catch (error) {
		logger.error(`Failed to create a poll in channel ${channelId}:`, error);
		throw error;
	}
}

export async function fetchPollStatus(channelId: string, messageId: string): Promise<PollStatusResponse> {
	try {
		const response = await http.get<PollStatusResponse>(Endpoints.CHANNEL_MESSAGE_POLL(channelId, messageId));
		return response.body;
	} catch (error) {
		logger.error(`Failed to load poll ${messageId}:`, error);
		throw error;
	}
}

export async function voteInPoll(
	channelId: string,
	messageId: string,
	answerIds: ReadonlyArray<number>,
): Promise<PollStatusResponse> {
	try {
		const response = await http.put<PollStatusResponse>(Endpoints.CHANNEL_MESSAGE_POLL_VOTES(channelId, messageId), {
			body: {answer_ids: [...answerIds]},
		});
		return response.body;
	} catch (error) {
		logger.error(`Failed to vote in poll ${messageId}:`, error);
		throw error;
	}
}

export async function endPoll(channelId: string, messageId: string): Promise<PollStatusResponse> {
	try {
		const response = await http.post<PollStatusResponse>(Endpoints.CHANNEL_MESSAGE_POLL_END(channelId, messageId), {
			body: {},
		});
		return response.body;
	} catch (error) {
		logger.error(`Failed to end poll ${messageId}:`, error);
		throw error;
	}
}
